/* Hocenlub home JS — 1:1 from source, guarded for Theme Editor re-render. */
(function(){if(window.__adHomeInit)return;window.__adHomeInit=true;
(function(){
  // Lenis smooth scroll (whole page)
  var lenis=null;
  if(window.Lenis && !window.matchMedia('(prefers-reduced-motion: reduce)').matches){
    lenis=new Lenis({duration:1.1,easing:function(t){return Math.min(1,1.001-Math.pow(2,-10*t))}});
    window.__adLenis=lenis;
    var rafL=function(time){lenis.raf(time);requestAnimationFrame(rafL)};
    requestAnimationFrame(rafL);
  }
  // smooth in-page anchor scrolling (with sticky-nav offset); dead "#" links do nothing
  document.querySelectorAll('a[href^="#"]').forEach(function(a){
    a.addEventListener('click',function(e){
      var id=a.getAttribute('href');
      if(!id||id.charAt(0)!=='#')return;
      if(id==='#'){e.preventDefault();return;}
      var el=document.querySelector(id);
      e.preventDefault();
      if(!el)return;
      if(lenis)lenis.scrollTo(el,{offset:-64});
      else el.scrollIntoView({behavior:'smooth'});
      var lk=document.querySelector('.nav-links');if(lk)lk.classList.remove('open');
    });
  });

  // hero push-up: scroll progress drives the hero's translate + scale + dim (Scout-style)
  var heroStage=document.querySelector('.hero-stage'),heroFront=document.getElementById('heroFront'),heroDim=document.getElementById('heroDim');
  if(heroStage&&heroFront&&!window.matchMedia('(prefers-reduced-motion: reduce)').matches){
    var hTick=false;
    var heroFrame=function(){
      var rect=heroStage.getBoundingClientRect();
      var dist=heroStage.offsetHeight-window.innerHeight;
      var p=Math.min(1,Math.max(0,-rect.top/(dist||1)));
      heroFront.style.transform='translate3d(0,'+(-p*100).toFixed(3)+'%,0)';
      if(heroDim)heroDim.style.opacity=(p*0.85).toFixed(3);
    };
    window.addEventListener('scroll',function(){if(!hTick){requestAnimationFrame(function(){heroFrame();hTick=false});hTick=true;}},{passive:true});
    window.addEventListener('resize',heroFrame);
    heroFrame();
  }

  // nav behavior: hidden while scrolling through the hero (first screen); once the
  // hero scrolls past, the nav appears and stays permanently. Shown at the very top.
  // Geometry-based so it works with Lenis smooth scroll (which keeps window.scrollY
  // near 0 and translates content): read the hero's viewport-relative rect.
  var nav=document.getElementById('nav');
  var heroStage=document.querySelector('.hero-stage');
  function navTick(){
    if(!heroStage){nav.classList.remove('-hidden');nav.classList.add('scrolled');return;}
    var r=heroStage.getBoundingClientRect();
    nav.classList.toggle('scrolled',r.top<-10);
    // Show once the next section (brandstrip) starts entering the viewport — i.e. the
    // hero's bottom edge crosses into view — and keep it shown from then on.
    if(r.bottom<=window.innerHeight){nav.classList.remove('-hidden');}  // next part entering -> show & stay
    else if(r.top>=-8){nav.classList.remove('-hidden');}               // at the very top -> show
    else{nav.classList.add('-hidden');}                                // mid-hero scroll -> hide
  }
  navTick();
  window.addEventListener('scroll',navTick,{passive:true});
  window.addEventListener('resize',navTick,{passive:true});
  var burger=document.getElementById('burger'),links=document.querySelector('.nav-links');
  var navScrim=document.createElement('div');navScrim.className='nav-scrim';document.body.appendChild(navScrim);
  function navLock(){document.documentElement.classList.toggle('nav-open',!!(document.querySelector('.nav-links.open')||document.querySelector('.nav-search.open')));}
  window.__navLock=navLock;
  function setDrawer(o){if(!links)return;links.classList.toggle('open',o);navScrim.classList.toggle('open',o);navLock();}
  if(burger)burger.addEventListener('click',function(){setDrawer(!links.classList.contains('open'));});
  if(links)links.addEventListener('click',function(e){if(e.target.tagName==='A')setDrawer(false);});
  navScrim.addEventListener('click',function(){setDrawer(false);});

  var ro=new IntersectionObserver(function(es){es.forEach(function(en){if(en.isIntersecting){en.target.classList.add('in');ro.unobserve(en.target)}})},{threshold:0.15});
  function bindReveals(){document.querySelectorAll('.reveal:not(.in)').forEach(function(el){ro.observe(el)})}
  bindReveals();
  window.__bindReveals=bindReveals;

  // hero slider
  var slides=[].slice.call(document.querySelectorAll('.hero .slide'));
  if(slides.length){
    var dotsWrap=document.getElementById('heroDots'),i=0,timer,N=slides.length;
    var reduce=window.matchMedia('(prefers-reduced-motion:reduce)').matches;
    slides.forEach(function(_,n){var b=document.createElement('button');if(n===0)b.className='on';b.setAttribute('aria-label','Go to slide '+(n+1));b.addEventListener('click',function(){go(n)});dotsWrap.appendChild(b)});
    var dots=[].slice.call(dotsWrap.children);
    function go(n){slides[i].classList.remove('active');dots[i].classList.remove('on');i=(n+N)%N;slides[i].classList.add('active');dots[i].classList.add('on');restart()}
    function next(){go(i+1)} function prev(){go(i-1)}
    function restart(){if(reduce)return;clearInterval(timer);timer=setInterval(next,6000)}
    document.getElementById('heroNext').addEventListener('click',next);
    document.getElementById('heroPrev').addEventListener('click',prev);
    var hero=document.querySelector('.hero');
    hero.addEventListener('mouseenter',function(){clearInterval(timer)});
    hero.addEventListener('mouseleave',restart);
    var x0=null;
    hero.addEventListener('touchstart',function(e){x0=e.touches[0].clientX},{passive:true});
    hero.addEventListener('touchend',function(e){if(x0===null)return;var dx=e.changedTouches[0].clientX-x0;if(Math.abs(dx)>40){dx<0?next():prev()}x0=null});
    restart();
  }

  // count-up stats
  var nums=[].slice.call(document.querySelectorAll('.stat-num'));
  if(nums.length){
    var rdc=window.matchMedia('(prefers-reduced-motion:reduce)').matches;
    var runCount=function(el){
      var to=+el.dataset.to,pre=el.dataset.prefix||'',suf=el.dataset.suffix||'',start=null,dur=1400;
      if(rdc){el.textContent=pre+to+suf;return}
      function tick(t){if(!start)start=t;var p=Math.min((t-start)/dur,1);var v=Math.round((1-Math.pow(1-p,3))*to);el.textContent=pre+v+suf;if(p<1)requestAnimationFrame(tick)}
      requestAnimationFrame(tick);
    };
    var co=new IntersectionObserver(function(es){es.forEach(function(en){if(en.isIntersecting){runCount(en.target);co.unobserve(en.target)}})},{threshold:0.6});
    nums.forEach(function(n){co.observe(n)});
  }

  // product swatches
  var swWrap=document.getElementById('swatches'),prodImg=document.getElementById('prodImg');
  if(swWrap&&prodImg){
    swWrap.addEventListener('click',function(e){
      var b=e.target.closest('.sw');if(!b)return;
      swWrap.querySelectorAll('.sw').forEach(function(s){s.classList.remove('on')});
      b.classList.add('on');
      prodImg.style.opacity=0;
      setTimeout(function(){prodImg.src=b.dataset.img;prodImg.style.opacity=1},200);
    });
  }

  // A/B airflow drag-compare slider
  var ab=document.getElementById('abCompare');
  if(ab){
    var abTop=ab.querySelector('.ab-top'),abHl=ab.querySelector('.ab-hl'),abGrip=ab.querySelector('.ab-grip'),abDown=false;
    var abSet=function(x){var r=ab.getBoundingClientRect();var p=Math.max(0,Math.min(1,(x-r.left)/r.width));abTop.style.clipPath='inset(0 '+((1-p)*100)+'% 0 0)';abHl.style.left=(p*100)+'%';abGrip.style.left=(p*100)+'%';};
    ab.addEventListener('pointerdown',function(e){abDown=true;ab.setPointerCapture&&ab.setPointerCapture(e.pointerId);abSet(e.clientX)});
    ab.addEventListener('pointermove',function(e){if(abDown)abSet(e.clientX)});
    window.addEventListener('pointerup',function(){abDown=false});
  }

  // scroll-zoom pinned reveal
  var zoom=document.getElementById('story');
  if(zoom){
    var zMedia=document.getElementById('zoomMedia'),zIntro=document.getElementById('zoomIntro'),zOv=document.getElementById('zoomOverlay'),zRule=document.getElementById('zoomRule');
    var reduceZ=window.matchMedia('(prefers-reduced-motion:reduce)').matches;
    var clampZ=function(v){return Math.max(0,Math.min(1,v))};
    var lerpZ=function(a,b,t){return a+(b-a)*t};
    var isStaticZ=function(){return reduceZ||window.innerWidth<=760;};
    var frameZ=function(){
      var rect=zoom.getBoundingClientRect();
      var total=zoom.offsetHeight-window.innerHeight;
      var p=clampZ(-rect.top/(total||1));
      var g=clampZ(p/0.72);
      zMedia.style.top=lerpZ(18,0,g)+'%';
      zMedia.style.left=lerpZ(48,0,g)+'%';
      zMedia.style.width=lerpZ(46,100,g)+'%';
      zMedia.style.height=lerpZ(58,100,g)+'%';
      zMedia.style.borderRadius=lerpZ(10,0,g)+'px';
      zIntro.style.opacity=1-clampZ(p/0.32);
      var ov=clampZ((p-0.72)/0.2);
      zOv.style.opacity=ov;zRule.style.transform='scaleX('+ov+')';
    };
    var zTick=false;
    var onScrollZ=function(){if(isStaticZ())return;if(!zTick){requestAnimationFrame(function(){frameZ();zTick=false});zTick=true;}};
    var applyZ=function(){
      if(isStaticZ()){zoom.classList.add('is-static');zMedia.removeAttribute('style');zIntro.style.opacity='';zOv.style.opacity='';zRule.style.transform='';}
      else{zoom.classList.remove('is-static');frameZ();}
    };
    window.addEventListener('scroll',onScrollZ,{passive:true});
    window.addEventListener('resize',applyZ);
    applyZ();
  }

  // featured row arrows
  var fr=document.getElementById('featRow');
  if(fr){
    var step=function(){return Math.min(460,fr.clientWidth*0.85)};
    document.getElementById('featPrev').addEventListener('click',function(){fr.scrollBy({left:-step(),behavior:'smooth'})});
    document.getElementById('featNext').addEventListener('click',function(){fr.scrollBy({left:step(),behavior:'smooth'})});
  }

  // UGC row arrows
  var ur=document.getElementById('ugcRow');
  if(ur){
    var ustep=function(){return Math.min(420,ur.clientWidth*0.8)};
    document.getElementById('ugcPrev').addEventListener('click',function(){ur.scrollBy({left:-ustep(),behavior:'smooth'})});
    document.getElementById('ugcNext').addEventListener('click',function(){ur.scrollBy({left:ustep(),behavior:'smooth'})});
  }

  // newsletter — AJAX submit so the heavy home page does NOT fully reload (instant "you're in")
  var nf=document.getElementById('newsForm');
  if(nf){
    nf.addEventListener('submit',function(e){
      if(nf.dataset.native)return;            // fallback path: let it submit natively
      e.preventDefault();
      var btn=nf.querySelector('button[type="submit"]'),email=nf.querySelector('input[type="email"]'),ok=nf.querySelector('.news-ok');
      if(email && !email.checkValidity()){email.reportValidity();return;}
      var orig=btn?btn.textContent:'';if(btn){btn.disabled=true;btn.textContent='…';}
      fetch(nf.getAttribute('action'),{method:'POST',body:new FormData(nf),headers:{'Accept':'text/html'}})
        .then(function(r){return r.text();})
        .then(function(html){
          if(html.indexOf('needs to be verified')>-1){nf.dataset.native='1';nf.submit();return;} // bot check -> native
          if(ok)ok.hidden=false;
          if(email)email.value='';
          if(btn){btn.textContent=orig;btn.disabled=false;}
        })
        .catch(function(){nf.dataset.native='1';nf.submit();});
    });
  }

  // nav search panel
  var sToggle=document.getElementById('navSearchToggle'),sPanel=document.getElementById('navSearch'),sClose=document.getElementById('navSearchClose');
  if(sToggle&&sPanel){
    var openSearch=function(){sPanel.classList.add('open');sPanel.setAttribute('aria-hidden','false');sToggle.setAttribute('aria-expanded','true');if(window.__navLock)window.__navLock();var inp=sPanel.querySelector('.nav-search-input');if(inp)setTimeout(function(){inp.focus()},80);};
    var closeSearch=function(){sPanel.classList.remove('open');sPanel.setAttribute('aria-hidden','true');sToggle.setAttribute('aria-expanded','false');if(window.__navLock)window.__navLock();};
    sToggle.addEventListener('click',function(e){e.preventDefault();sPanel.classList.contains('open')?closeSearch():openSearch();});
    if(sClose)sClose.addEventListener('click',closeSearch);
    document.addEventListener('keydown',function(e){if(e.key==='Escape')closeSearch();});
    document.addEventListener('click',function(e){if(sPanel.classList.contains('open')&&!sPanel.contains(e.target)&&!sToggle.contains(e.target))closeSearch();});
  }

  if(window.__bindReveals)window.__bindReveals();
})();

})();
